module.exports = __webpack_public_path__ + "img/Wp_2074.9c15e394.png";